import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=a159f8dc&scoped=true"
import script from "./ProjectSelect.vue?vue&type=script&lang=js"
export * from "./ProjectSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a159f8dc",
  null
  
)

export default component.exports